import { Breadcrumbs, Button, DetailDrawer } from "InnoUI/components";
import SC from "./style";
import { useLocation, useNavigate } from "react-router";
import theme from "@theme";
import { apiGet, apiPost } from "api/callApi";
import { useEffect, useState } from "react";
import AddEditFolder from "../AddEditFolder";
import Folder from "../FolderTree/Folder";
import NoProject from "./NoProject";
import InnoIcons from "@InnoIcons/";
import FolderTemplateEditor from "../FolderTemplateEditor";
import TooltipText from "components/TooltipText";
import { Switch } from "antd";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

const FolderPermissionAndStructure = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;
  const { data } = location.state || {};
  const [folders, setFolders] = useState([]);
  const [openModalView, setOpenModalView] = useState(false);
  const [modalRowData, setModalRowData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isSubFolder, setIsSubFolder] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [openDrawer, setOpenSDrawer] = useState(false);
  const [changeLinkProject, setChangeLinkProject] = useState(true); // State for checkbox
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [selectedOccupants, setSelectedOccupants] = useState([]);
  const [totalOccupants, setTotalOccupants] = useState([]);
  const [totalProjects, setTotalProjects] = useState([]);
  const [dataa, setData] = useState([]);
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const templateId = searchParams.get("templateId");

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || []
  );

  const breadcrumbItems = [
    { label: "Admin Settings" },
    { label: "Folder Template", href: "/admin-settings/folder-template" },
    {
      label: `${data?.name || ""}`,
      href: "/admin-settings/folder-template/permission-and-structure",
    },
  ];

  // const breadcrumbItemstype = [
  //   { label: `${currentProject.propertyName || ""}`, href: `/project-home` },
  //   { label: "General Information" },
  // ];

  const handleBreadcrumbClick = (href) => {
    if (href) {
      navigate(href, { state: { data } });
    }
  };

  const handleBackClick = () => {
    if (window.history.state && window.history.state.idx >= 0) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  // function to get Folder Data
  const getFolderData = async () => {
    try {
      const result = await apiGet(
        `/v1/folder/${templateId ? templateId : data?.id}`,
        false
      );
      if (result.data) {
        setFolders([...result.data]);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    getFolderData();
  }, []);

  // Filter folder types based on the normalized search term (removing spaces)
  const normalizedSearchTerm = searchTerm.replace(/\s+/g, "").toLowerCase();
  const filteredFolderTypes = folders.filter(({ name }) =>
    name.replace(/\s+/g, "").toLowerCase().includes(normalizedSearchTerm)
  );

  const handleEditModal = (data) => {
    setOpenModalView(true);
    if (data) {
      setIsEditing(true);
      setModalRowData(data);
    }
  };
  const handleAddOpenModal = () => {
    setOpenModalView(true);
    setIsEditing(false);
    setIsSubFolder(false);

    setModalRowData(null);
  };

  const handleAddSubFolder = (data) => {
    setOpenModalView(true);
    if (data) {
      setIsEditing(false);
      setModalRowData(data);
      setIsSubFolder(true);
    }
  };

  const closeDrawer = () => {
    setOpenSDrawer(false);
  };
  const handleOpenDrawer = () => {
    setOpenSDrawer(true);
  };

  const handleHideInactiveChange = (checked) => {
    // const checked = e.target.checked;
    setChangeLinkProject(checked);
  };

  const getProjectOccupantListAPI = async () => {
    try {
      const response = await apiPost(
        `/v1/templates/used/${templateId ? templateId : data?.id}`
      );
      const projectData = response?.data?.projectData;
      const occupantData = response?.data?.occupantData;
      setTotalProjects(projectData);
      setSelectedProjects(projectData.map((item) => item.id));
      setSelectedOccupants(occupantData.map((item) => item.occupantId));
      setTotalOccupants(occupantData);
      setData(response.data);
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    getProjectOccupantListAPI();
  }, []);

  /* useEffect(() => {
    console.log(selectedOccupants, totalOccupants, "op");

    if (selectedProjects.length == 0 && selectedOccupants.length == 0) {
      setChangeLinkProject(false);
    }
  }, [selectedProjects, selectedOccupants]); */

  return (
    <>
      <Breadcrumbs
        items={breadcrumbItems}
        separator=">"
        currentPath={currentPath}
        onClick={handleBreadcrumbClick}
      />
      <SC.TemplateNameContainer>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "50%",
          }}
        >
          <SC.ArrowBackIcon onClick={handleBackClick} />
          <SC.TemplateName>
            <TooltipText title={data?.name} maxLength={500} />
          </SC.TemplateName>
          <SC.InputContiner>
            <SC.SearchIcon />
            <SC.InputStyle
              placeholder={"Search by Folder"}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </SC.InputContiner>
        </div>

        {filteredFolderTypes.length > 0 && (
          <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <span style={{ fontSize: "12px" }}>
                Total Projects: {totalProjects?.length || 0} | Selected
                Projects:
                {selectedProjects.length || 0}
              </span>
              <span style={{ fontSize: "12px" }}>
                Total Occupants: {totalOccupants?.length || 0} | Selected
                Occupants:{selectedOccupants.length || 0}
              </span>
            </div>
            <Button
              caption={"Select Projects/Occupants"}
              type="submit"
              color="black"
              onClick={handleOpenDrawer}
              fontSize="0.75rem"
              rightIcon={
                <InnoIcons.KeyboardDoubleArrowRightIcon
                  sx={{ color: "black", fontSize: "16px", gap: "10px" }}
                />
              }
              style={{
                background: theme.colors.cancelButton,
                color: theme.colors.white,
                minWidth: "120px",
                height: "30px",
                borderRadius: "3px",
              }}
            />

            <Button
              caption={"+ New Folder"}
              type="submit"
              color="white"
              onClick={handleAddOpenModal}
              fontSize="0.75rem"
              style={{
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "100px",
                height: "30px",
                borderRadius: "3px",
              }}
            />
          </div>
        )}
      </SC.TemplateNameContainer>

      <SC.Container>
        <SC.FolderContainer>
          <SC.FChildren>
            <SC.FolderSpan>Folder Structure</SC.FolderSpan>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span style={{ fontSize: "12px" }}>
                Apply changes in selected projects and occupants
              </span>
              <Switch
                onChange={handleHideInactiveChange}
                checked={changeLinkProject}
                style={{
                  transform: "scale(0.7)",
                  backgroundColor: changeLinkProject
                    ? `${theme.colors.themeColor}`
                    : undefined,
                  borderColor: changeLinkProject
                    ? `${theme.colors.themeColor}`
                    : undefined,
                }}
                disabled={
                  selectedProjects.length == 0 && selectedOccupants.length == 0
                }
              />
            </div>
          </SC.FChildren>
          {filteredFolderTypes.length > 0 ? (
            <SC.FolderStructureContainer>
              {filteredFolderTypes.map((folder) => (
                <Folder
                  key={folder.id}
                  folder={folder}
                  fetchData={getFolderData}
                  handleEditModal={handleEditModal}
                  handleAddSubFolder={handleAddSubFolder}
                  selectedProjects={changeLinkProject ? selectedProjects : []}
                  selectedOccupants={changeLinkProject ? selectedOccupants : []}
                  changeLinkProject={changeLinkProject}
                />
              ))}
            </SC.FolderStructureContainer>
          ) : (
            <NoProject handleAddOpenModal={handleAddOpenModal} />
          )}
        </SC.FolderContainer>
      </SC.Container>

      {openModalView && (
        <AddEditFolder
          setOpenModalView={setOpenModalView}
          openModalView={openModalView}
          folderData={modalRowData}
          setModalRowData={setModalRowData}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          parentId={modalRowData?.id || null}
          templateId={data?.id}
          fetchData={getFolderData}
          isSubFolder={isSubFolder}
          selectedProjects={changeLinkProject ? selectedProjects : []}
          selectedOccupants={changeLinkProject ? selectedOccupants : []}
        />
      )}
      {openDrawer && (
        <DetailDrawer
          open={openDrawer}
          onClose={closeDrawer}
          title={false}
          width={"700px"}
          children={
            <FolderTemplateEditor
              onClose={closeDrawer}
              templateId={data?.id}
              selectedProjects={selectedProjects}
              setSelectedProjects={setSelectedProjects}
              selectedOccupants={selectedOccupants}
              setSelectedOccupants={setSelectedOccupants}
              setTotalProjects={setTotalProjects}
              setTotalOccupants={setTotalOccupants}
              data={dataa}
            />
          }
        />
      )}
    </>
  );
};

export default FolderPermissionAndStructure;
